export function formatAbn(abn: string | undefined | null) {
    if(abn == null || abn.length !== 11) {
        return abn;
    }

    const [a, b, c, d, e, f, g, h, i, j, k] = abn.split('');

    return `${a}${b} ${c}${d}${e} ${f}${g}${h} ${i}${j}${k}`;
}